//-------------------------------------------------------------------------------------------------- Imports
import {
    AuditOutlined,
    BellOutlined,
    DiffOutlined,
    DollarOutlined,
    FileDoneOutlined,
    FileProtectOutlined,
    FireOutlined,
    IdcardOutlined,
    MobileOutlined,
    NotificationOutlined,
    PhoneOutlined, TeamOutlined, UnorderedListOutlined, WifiOutlined
} from "@ant-design/icons";
import { MenuProps } from "rc-menu";
import { StyleSheet } from "../StyleSheet";
// import Config from "../views/config/Config";
import AccountState from "../views/accountState/AccountState";
import AssociatedContracts from "../views/associatedContracts/AssociatedContracts";
import CallHistory from "../views/callHistory/CallHistory";
import MyID from "../views/myId/MyID";
import MyServices from "../views/myServices/MyServices";
import Payment from "../views/payment/Payment";
import TechnicalSupport from "../views/technicalSupport/TechnicalSupport";
import TermsAndConditions from "../views/termsAndConditions/TermsAndConditions";
import PaymentCenter from "../views/payment/PaymentCenter";
import LastPayments from "../views/payment/LastPayments";
import PaymentDirect from "../views/payment/PaymentDirect";
import PaymentCard from "../views/payment/PaymentCard";
import PaymentCis from "../views/payment/PaymentCis";
import PaypalPayment from "../views/payment/PaypalPayment";
import FrequentlyAskedQuestions from "../views/technicalSupport/FrequentlyAskedQuestions";
import ChannelList from "../views/technicalSupport/ChannelList";
import TechnicalDiagnostics from "../views/technicalSupport/TechnicalDiagnostics";
import Portability from "../views/portability/Portability";
import WifiPoints from "../views/wifiPoints/WifiPoints";
import Notifications from "../views/notifications/Notifications";
import Promotions from "../views/promotions/Promotions";
import MobileTelephony from "../views/mobilTelephony/MobileTelephony";
import { ReactNode } from "react";
import { Route } from "react-router-dom";
import BillingData from "../views/myId/BillingData";
import ReferralSystem from "../views/referral/ReferralSystem";
import ShareCode from "../views/referral/ShareCode";
import RegisterCode from "../views/referral/RegisterCode";
import ReportDiscounts from "../views/referral/ReportDiscounts";
import DownloadBilling from "../views/myId/DownloadBilling";
import UpdateSuscriptorData from "../views/config/UpdateSuscriptorData";
import BillingHome from "../views/billing/BillingHome";
import OrderService from "../views/technicalSupport/OrderService";
import MyNetworkList from "../views/technicalSupport/MyNetworkList";
import MeganChat from "../views/technicalSupport/MeganChat";

type MenuItem = Required<MenuProps>['items'][number];

export const getItem = (
    label: React.ReactNode, key: React.Key, icon?: React.ReactNode, children?: MenuItem[], type?: 'group'
): MenuItem => {
    return {
        key,
        icon,
        children,
        label,
        type,
    } as MenuItem;
};

//-------------------------------------------------------------------------------------------------- Styles
const iconStylesMenuItem = StyleSheet.create({
    iconStyles: {
        fontSize: 20,
        color: "#0055ba",
    }
});

//-------------------------------------------------------------------------------------------------- Paths
export let MENU_ITEMS: MenuItem[] = [
    getItem('Mis Datos', "/my-data", <IdcardOutlined style={iconStylesMenuItem.iconStyles} />),
    getItem('Mis Servicios', "/my-services", <UnorderedListOutlined style={iconStylesMenuItem.iconStyles} />),
    getItem('Pagos', "/payments", <DollarOutlined style={iconStylesMenuItem.iconStyles} />),
    getItem('Estado de Cuenta', "/statement", <FileDoneOutlined style={iconStylesMenuItem.iconStyles} />),
    getItem('Facturación', "/billing", <DiffOutlined style={iconStylesMenuItem.iconStyles} />),
    getItem('Recomienda Mega', "/referral-system", <FireOutlined style={iconStylesMenuItem.iconStyles} />),
    getItem('Soporte Técnico', "/technical-support", <TeamOutlined style={iconStylesMenuItem.iconStyles} />),
    getItem('Contratos Asociados', "/associated-contracts", <AuditOutlined style={iconStylesMenuItem.iconStyles} />),
    getItem('Historial de Llamadas', "/calls-history", <PhoneOutlined style={iconStylesMenuItem.iconStyles} />),
    getItem('Telefonía Móvil', "/mobile-telephony", <MobileOutlined style={iconStylesMenuItem.iconStyles} />),
    getItem('Notificaciones', "/notifications", <BellOutlined style={iconStylesMenuItem.iconStyles} />),
    getItem('Promociones', "/promotions", <NotificationOutlined style={iconStylesMenuItem.iconStyles} />),
    getItem('Términos y Condiciones', "/terms-and-conditions", <FileProtectOutlined style={iconStylesMenuItem.iconStyles} />),
    // getItem('Configuración', "/settings", <SettingOutlined style={iconStylesMenuItem.iconStyles} />),
    getItem('Puntos Wifi', "/wifi-points", <WifiOutlined style={iconStylesMenuItem.iconStyles} />),
];

//-------------------------------------------------------------------------------------------------- Routes
export const ProgramRoutes: Array<ReactNode> = [
    <Route path={"/my-data"} element={<MyID />} />,
    <Route path={"/my-data/update-data"} element={<UpdateSuscriptorData />} />,
    <Route path={"/my-services"} element={<MyServices />} />,
    <Route path={"/portability"} element={<Portability />} />,
    <Route path={"/payments"} element={<Payment />} />,
    <Route path={"/payments/monthly-payment"} element={<PaymentDirect />} />,
    <Route path={"/payments/card-payment"} element={<PaymentCard />} />,
    <Route path={"/payments/paypal"} element={<PaypalPayment />} />,
    <Route path={"/payments/payment-centers"} element={<PaymentCenter />} />,
    <Route path={"/payments/payment-cis"} element={<PaymentCis />} />,
    <Route path={"/payments/history"} element={<LastPayments />} />,
    <Route path={"/statement"} element={<AccountState />} />,
    <Route path={"/technical-support"} element={<TechnicalSupport />} />,
    <Route path={"/technical-support/frequently-question"} element={<FrequentlyAskedQuestions />} />,
    <Route path={"/technical-support/channel-list"} element={<ChannelList />} />,
    <Route path={"/technical-support/technical-diagnostics"} element={<TechnicalDiagnostics />} />,
    <Route path={"/mobile-telephony"} element={<MobileTelephony />} />,
    <Route path={"/notifications"} element={<Notifications />} />,
    <Route path={"/associated-contracts"} element={<AssociatedContracts />} />,
    <Route path={"/calls-history"} element={<CallHistory />} />,
    <Route path={"/wifi-points"} element={<WifiPoints />} />,
    <Route path={"/promotions"} element={<Promotions />} />,
    <Route path={"/terms-and-conditions"} element={<TermsAndConditions />} />,
    // <Route path={"/settings"} element={<Config />} />,
    <Route path={"/billing"} element={<BillingHome />} />,
    <Route path={"/billing/billing-data"} element={<BillingData />} />,
    <Route path={"/billing/download-billing"} element={<DownloadBilling />} />,
    <Route path={"/referral-system"} element={<ReferralSystem />} />,
    <Route path={"/referral-system/share-code"} element={<ShareCode />} />,
    <Route path={"/referral-system/register-code"} element={<RegisterCode />} />,
    <Route path={"/referral-system/report-discounts"} element={<ReportDiscounts />} />,
    <Route path={"/technical-support/order-service"} element={<OrderService />} />,
    <Route path={"/technical-support/my-network"} element={<MyNetworkList />} />,
    <Route path={"/technical-support/megan-chat"} element={<MeganChat />} />,
    <Route path="*" element={<MyID />} />,
];

interface RouteType {
    path: string;
    element: React.ReactElement;
    breadcrumb: string;
}

export const routes: RouteType[] = [
    {
        path: "/",
        element: <MyID />,
        breadcrumb: "",
    },
    {
        path: "/my-data",
        element: <MyID />,
        breadcrumb: "Mis Datos"
    },
    {
        path: "/my-data/update-data",
        element: <UpdateSuscriptorData />,
        breadcrumb: "Actualizar Datos"
    },
    {
        path: "/my-services",
        element: <MyServices />,
        breadcrumb: "Mis Servicios"
    },
    {
        path: "/portability",
        element: <Portability />,
        breadcrumb: "Porta tu línea"
    },
    {
        path: "/payments",
        element: <Payment />,
        breadcrumb: "Pagos / Formas de Pago"
    },
    {
        path: "/payments/monthly-payment",
        element: <PaymentDirect />,
        breadcrumb: "Domiciliar Pago"
    },
    {
        path: "/payments/card-payment",
        element: <PaymentCard />,
        breadcrumb: "Pago con Tarjeta"
    },
    {
        path: "/payments/paypal",
        element: <PaypalPayment />,
        breadcrumb: "Pagar con Paypal"
    },
    {
        path: "/payments/payment-centers",
        element: <PaymentCenter />,
        breadcrumb: "Pagar en Centros de Cobro Asociados"
    },
    {
        path: "/payments/payment-cis",
        element: <PaymentCis />,
        breadcrumb: "Pagar en CIS"
    },
    {
        path: "/payments/history",
        element: <LastPayments />,
        breadcrumb: "Últimos Pagos"
    },
    {
        path: "/statement",
        element: <AccountState />,
        breadcrumb: "Estado de Cuenta"
    },
    {
        path: "/technical-support",
        element: <TechnicalSupport />,
        breadcrumb: "Soporte Técnico"
    },
    {
        path: "/technical-support/frequently-question",
        element: <FrequentlyAskedQuestions />,
        breadcrumb: "Preguntas Frecuentes"
    },
    {
        path: "/notifications",
        element: <Notifications />,
        breadcrumb: "Notificaciones"
    },
    {
        path: "/technical-support/channel-list",
        element: <ChannelList />,
        breadcrumb: "Lista de Canales de TV"
    },
    {
        path: "/technical-support/order-service",
        element: <OrderService />,
        breadcrumb: "Órdenes de Servicio"
    },
    {
        path: "/technical-support/technical-diagnostics",
        element: <TechnicalDiagnostics />,
        breadcrumb: "Diagnóstico Técnico"
    },
    {
        path: "/technical-support/my-network",
        element: <MyNetworkList />,
        breadcrumb: "Mi Módem"
    },
    {
        path: "/technical-support/megan-chat",
        element: <MeganChat />,
        breadcrumb: "Chat Megan"
    },
    {
        path: "/associated-contracts",
        element: <AssociatedContracts />,
        breadcrumb: "Contratos Asociados"
    },
    {
        path: "/wifi-points",
        element: <WifiPoints />,
        breadcrumb: "Puntos Wifi"
    },
    {
        path: "/promotions",
        element: <Promotions />,
        breadcrumb: "Promociones"
    },
    {
        path: "/calls-history",
        element: <CallHistory />,
        breadcrumb: "Historial de Llamadas"
    },
    {
        path: "/terms-and-conditions",
        element: <TermsAndConditions />,
        breadcrumb: "Términos y Condiciones"
    },
    // {
    //     path: "/settings",
    //     element: <Config />,
    //     breadcrumb: "Configuración"
    // },
    {
        path: "/mobile-telephony",
        element: <MobileTelephony />,
        breadcrumb: "Telefonía Móvil"
    },
    {
        path: "/referral-system",
        element: <ReferralSystem />,
        breadcrumb: "Recomienda Mega"
    },
    {
        path: "/referral-system/share-code",
        element: <ShareCode />,
        breadcrumb: "Compartir Código"
    },
    {
        path: "/referral-system/register-code",
        element: <RegisterCode />,
        breadcrumb: "Registrar Código"
    },
    {
        path: "/referral-system/report-discounts",
        element: <ReportDiscounts />,
        breadcrumb: "Reporte de Descuentos"
    },
    {
        path: "/billing",
        element: <BillingHome />,
        breadcrumb: "Facturación"
    },
    {
        path: "/billing/billing-data",
        element: <BillingData />,
        breadcrumb: "Datos de facturación"
    },
    {
        path: "/billing/download-billing",
        element: <DownloadBilling />,
        breadcrumb: "Descargar Facturas"
    },
];
